export var EDeviceBufferUsage;
(function (EDeviceBufferUsage) {
    EDeviceBufferUsage[EDeviceBufferUsage["MAP_READ"] = 1] = "MAP_READ";
    EDeviceBufferUsage[EDeviceBufferUsage["MAP_WRITE"] = 2] = "MAP_WRITE";
    EDeviceBufferUsage[EDeviceBufferUsage["COPY_SRC"] = 4] = "COPY_SRC";
    EDeviceBufferUsage[EDeviceBufferUsage["COPY_DST"] = 8] = "COPY_DST";
    EDeviceBufferUsage[EDeviceBufferUsage["STORAGE"] = 16] = "STORAGE";
    EDeviceBufferUsage[EDeviceBufferUsage["INDIRECT"] = 32] = "INDIRECT";
    EDeviceBufferUsage[EDeviceBufferUsage["VERTEX"] = 64] = "VERTEX";
})(EDeviceBufferUsage || (EDeviceBufferUsage = {}));
